import { withSubComponents } from 'utils/react';
import PrimaryCard, { DataRow } from './PrimaryCard';

export default withSubComponents(PrimaryCard, {
    Row: DataRow,
});